import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

function Login() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      setError('');
      setLoading(true);
      console.log('Attempting Google login');
      
      const user = await loginWithGoogle();
      
      if (user) {
        console.log('Google login successful, getting token');
        // Save token to localStorage
        const token = await user.getIdToken();
        localStorage.setItem('authToken', token);
        console.log('Token saved, navigating to dashboard');
        navigate('/dashboard');
      } else {
        console.error('No user returned from Google login');
        setError('Google login failed: No user data returned');
      }
    } catch (err) {
      console.error('Google login error details:', err);
      
      // Create a more user-friendly error message based on Firebase error codes
      let errorMessage = 'Failed to log in with Google: ';
      
      if (err.code === 'auth/popup-closed-by-user') {
        errorMessage = 'Login cancelled - you closed the popup';
      } else if (err.code === 'auth/popup-blocked') {
        errorMessage = 'Popup blocked by browser - please enable popups for this site';
      } else if (err.code === 'auth/cancelled-popup-request') {
        errorMessage = 'Login cancelled';
      } else if (err.code === 'auth/network-request-failed') {
        errorMessage += 'Network error - please check your connection';
      } else {
        errorMessage += err.message || 'Unknown error occurred';
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>JurisAI</h1>
        <h2>Sign In</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <button 
          className="google-button" 
          onClick={handleGoogleLogin} 
          disabled={loading}
        >
          <span className="google-icon">G</span>
          {loading ? 'Signing in...' : 'Sign in with Google'}
        </button>
        
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <Link 
            to="/debug" 
            style={{
              fontSize: '12px',
              color: '#666',
              textDecoration: 'none'
            }}
          >
            Debug Mode
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;